
export const ErrorHandling = (error) => {
  if (error.response?.status === 401) {
    setTimeout(() => {
      window.location.href = "/login";
    }, 0);
  } else {
    const message =
      (error.response && error.response.data.message) ||
      error.message ||
      error.toString();
    // toast.error(message, {
    //   theme: "colored",
    // });
  }
};

export default ErrorHandling;
